import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-appointment-status',
  templateUrl: './appointment-status.component.html',
  styleUrls: ['./appointment-status.component.css']
})
export class AppointmentStatusComponent implements OnInit {

  @Input() status: string;

  private _statusList: any = {
    0: {
      label: 'Pendente',
      css: 'badge-warning'
    },
    1: {
      label: 'Cancelada',
      css: 'badge-danger'
    },
    2: {
      label: 'Finalizada',
      css: 'badge-primary'
    }
  };

  getStatus(): any {
    let status = this._statusList[this.status];

    if (typeof status === 'undefined') {
      status = {
        label: '',
        css: 'badge-light'
      };
    }

    return status;
  }

  constructor() { }

  ngOnInit() {
  }

}
